import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[soloNumeros]'
})
export class SoloNumerosDirective {

  @HostListener('input', ['$event'])
  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/\D/g, '');
  }
}
